import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OriginalProductModel, UserProductModel } from '@/Models';
import { Nullable, UserProductTableRow } from '@/Types';
import { LogisticProduct } from '@/Models/UserProducts/LogisticProduct';
import { userProductsPageAsyncActions } from './asyncActions';
import { LogisticCountriesModel } from '@/Models/UserProducts/LogisticCountriesModel';

export type UserProductsState = {
  selectedProduct: Nullable<UserProductTableRow>;
  products: UserProductTableRow[];
  originalProducts: OriginalProductModel[];
  logisticProducts: LogisticProduct[];
  logisticCountries: LogisticCountriesModel[];
};

const initialState: UserProductsState = {
  selectedProduct: null,
  products: [],
  originalProducts: [],
  logisticProducts: [],
  logisticCountries: [],
};

const userProductsSlice = createSlice({
  name: 'userProducts',
  initialState,
  reducers: {
    selectProduct(state, action: PayloadAction<Nullable<UserProductModel>>) {
      state.selectedProduct = state.products.find((item) => item.id == action.payload?.id) ?? null;
    },
    clearData(state) {
      state.products = [];
      state.originalProducts = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userProductsPageAsyncActions.getAllProductsRequest.fulfilled, (state, action) => {
        state.products = action.payload;
      })
      .addCase(userProductsPageAsyncActions.createProductRequest.fulfilled, (state, action) => {
        const { product } = action.payload;

        if (product) {
          state.products.push(product);
          state.selectedProduct = product;
        }
      })
      .addCase(userProductsPageAsyncActions.updateProductRequest.fulfilled, (state, action) => {
        const { product } = action.payload;

        state.products = state.products.map((x) => {
          return x.id == product.id ? product : x;
        });
        state.selectedProduct = product;
      })
      .addCase(userProductsPageAsyncActions.deleteProductRequest.fulfilled, (state, action) => {
        state.products = state.products.filter((x) => x.id !== action.payload);
      })
      .addCase(userProductsPageAsyncActions.getAllOriginalProductsRequest.fulfilled, (state, action) => {
        state.originalProducts = action.payload;
      })
      .addCase(userProductsPageAsyncActions.getLogisticProducts.fulfilled, (state, action) => {
        state.logisticProducts = action.payload;
      })
      .addCase(userProductsPageAsyncActions.getLogisticCountries.fulfilled, (state, action) => {
        state.logisticCountries = action.payload.items;
      });
  },
});

const { actions, reducer } = userProductsSlice;

export const userProductsPageActions = actions;
export const userProductsPageReducer = reducer;
